import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getVMIContractItems = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vmi-contract-items/`, data);
        return await response.data.data;
    } catch (error) {
        console.log("getVMIContractItems - error", error)
        return handleApiError(error)
    }
}

export const searchVMIContractItems = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vmi-contract-items/search`, data);
        return await response.data
    } catch (error) {
        console.log("searchVMIContractItems - error", error)
        return handleApiError(error)
    }
}

export const insertVMIContractItems = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vmi-contract-items/bulk-create`, data);
        return await response.data.data;
    } catch (error) {
        console.log("insertVMIContractItems - error", error)
        return handleApiError(error)
    }
}

export const getVMICompanies = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vmi-contract-items/companies`, data);
        return await response.data.data;
    } catch (error) {
        console.log("getVMICompanies - error", error)
        return handleApiError(error)
    }
}

export const  getVMIContractsItemsByMaterialId = async (materialId) => {
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/vmi-contract-items/materialid/${materialId}`);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getVMIContractsItemsByMaterialId - error", error)
        return handleApiError(error)
    }
}

export const  getVMIContractsItemsByPermMaterialId = async (materialId) => {
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/vmi-contract-items/perm-materialid/${materialId}`);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getVMIContractsItemsByPermMaterialId - error", error)
        return handleApiError(error)
    }
}